module.exports = __webpack_public_path__ + "img/118.b3507a66.jpg";